export default "__VITE_ASSET__CRZLbaRl__"